import { parseParams } from "utilities/url/url";

import { BillDocumentType } from "entity/bill/Bill/Bill.api.types";

/**
 * Maps the `documentType` query param onto the enum the Bill form expects. Vendor Credit is the
 * only type addressable by URL today; anything else resolves to undefined so BillPresentational
 * applies its normal default.
 *
 * Shared by the desktop (`RouteBill`) and mobile webview (`BillWebviewContainer`) mount points.
 */
export const getInitialBillDocumentType = (search: string): BillDocumentType | undefined => {
    const { documentType } = parseParams<{ documentType?: string | string[] }>(search);
    const value = typeof documentType === "string" ? documentType : documentType?.[0];

    return value?.toLowerCase() === "vendorcredit" ? BillDocumentType.VendorCredit : undefined;
};
